<template>
  <div class="analytic-group is-primary">
    <level-left class="analytic-group-level">
      <multiselect
        v-model="logicalOperator"
        :options="operators"
        label="name"
        :show-labels="false"
        :close-on-select="true"
        :clear-on-select="false"
        :hide-selected="false"
        :allow-empty="false"
        :preselect-first="true"
        class="operator-select">
      </multiselect>
      <button @click="remove" class="delete"></button>
      <button
        type="button"
        class="button add level-item"
        @click="addExpression"
        v-html="labels.addAnalytic">
        <i class="fas fa-plus"></i>
      </button>

      <button
        type="button"
        class="button add level-item"
        v-if="this.depth < this.maxDepth"
        @click="addGroup"
        v-html="labels.addGroup">
        <i class="fas fa-plus"></i>
      </button>
    </level-left>
    <component
      v-for="(child, index) in children"
      :is="child.type"
      :key="child.id"
      :index="index"
      :depth="depth + 1"
      :fieldPrepend="fieldPrepend"
      :def="def"
      v-on:child-deletion-requested="removeChild"
      :expression.sync="child.expression">
    </component>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import LevelLeft from '@/components/LevelLeft.vue';
import QueryBuilderExpression from './QueryBuilderExpression.vue';

export default {
  name: 'QueryBuilderGroup',
  components: {
    QueryBuilderExpression,
    LevelLeft,
    Multiselect,
  },
  props: {
    depth: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    fieldPrepend: {
      type: String,
      required: true,
    },
    def: {
      type: Object,
      required: true,
    },
    expression: {
      type: String,
      required: true,
    },
  },
  watch: {
    def() {
      this.children = [];
    },
    computedExpression() {
      this.$emit('update:expression', this.computedExpression);
    },
  },
  data() {
    return {
      operators: [
        {
          name: 'All of the following are true',
          value: 'AND',
        },
        {
          name: 'One or more of the following are true',
          value: 'OR',
        },
      ],
      logicalOperator: {
        name: 'All of the following are true',
        value: 'AND',
      },
      maxDepth: 20,
      children: [],
      labels: {
        matchType: '',
        matchTypeAll: 'All of the following are true',
        matchTypeAny: 'One or more of the following are true',
        addAnalytic: 'Add Condition',
        removeAnalytic: '&times;',
        addGroup: 'Add Group',
        removeGroup: '&times;',
        textInputPlaceholder: 'value',
      },
    };
  },
  computed: {
    childCount() {
      return this.children.length;
    },
    computedExpression() {
      const expressions = this.children.map(child => child.expression);
      const expression = `( ${expressions.join(` ${this.logicalOperator.value} `)} )`;
      return expression;
    },
  },
  methods: {
    addExpression() {
      this.children.push({
        id: this.children.length,
        expression: '',
        type: 'query-builder-expression',
      });
    },
    removeChild(index) {
      this.children.splice(index, 1);
    },
    addGroup() {
      this.children.push({
        id: this.children.length,
        expression: '',
        type: 'query-builder-group',
      });
    },
    remove() {
      this.$emit('child-deletion-requested', this.index);
    },
  },
  mounted() {
    // groupExpression();
    if (this.children.length === 0) {
      this.addExpression();
    }
  },
};
</script>

<style lang="scss" scoped>

$spacing: 5px;

.analytic-group-level {
  margin-bottom: .5rem;
}

.operator-select {
  margin-right: 10px;
}

.analytic-group {
  padding: .5rem;
  border-radius: 0px;
  position: relative;
  border: 1px solid $border-color;

  button.delete {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }

  button.add {
    margin-right: 15px;
  }

  .field {
    margin-bottom: $spacing;
  }
}

.is-primary {
  background: grey;
}
</style>
